export const PER_PAGE = 20;

export const ASC = 'ASC';
export const DESC = 'DESC';

export const MANAGER = 'MANAGER';
export const ADMIN = 'ADMIN';
export const SUPPORT = 'SUPPORT';
export const SUPPORT_ADMIN = 'SUPPORT_ADMIN';

export const ACTION_PERMISSIONS = ['DB_RELEASE'];

export const OPEN = 'OPEN';
export const CLOSED = 'CLOSED';
export const DELETED = 'DELETED';
